/* eslint-disable-next-line import/named */
import { css } from 'styled-components';
export const injectTypography = ({ theme }, variant) => {
    const { fontFamily, fontSize, fontStretch, lineHeight } = theme.responsive.typography[variant] || {};
    return css `
    font-size: ${fontSize ? `var(${fontSize})` : undefined};
    font-family: ${fontFamily ? `var(${fontFamily})` : undefined};
    font-stretch: ${fontStretch ? `var(${fontStretch})` : undefined};
    line-height: ${lineHeight ? `var(${lineHeight})` : undefined};
  `;
};
//# sourceMappingURL=injectTypography.js.map